import { ChatMessage } from 'types/Chat'

interface ChatTurn {
  id: string
  messages: ChatMessage[]
}

const messagesToTurns = (messages: ChatMessage[]): ChatTurn[] => {
  const turns: ChatTurn[] = []

  messages.forEach((message) => {
    const currentTurn = turns[turns.length - 1]

    if (message.role === 'user' || message.role === 'system' || !currentTurn) {
      turns.push({ id: message.id, messages: [message] })
    } else {
      currentTurn.messages.push(message)
    }
  })

  return turns
}

export { messagesToTurns }
